import * as React from "react";
const SvgFiRrBreadSliceButter = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M13.768 8.73c-.943-.945-2.592-.945-3.535 0l-2.501 2.502a2.5 2.5 0 0 0 0 3.535l2.5 2.502a2.48 2.48 0 0 0 1.769.732c.668 0 1.296-.26 1.768-.732l2.5-2.502a2.5 2.5 0 0 0 0-3.535zm1.087 4.623-2.502 2.502a.501.501 0 0 1-.707 0l-2.501-2.502a.5.5 0 0 1 0-.708l2.502-2.502a.498.498 0 0 1 .706 0l2.5 2.502a.5.5 0 0 1 .002.708m9.079-8.174c-.385-2.383-2.571-4.18-5.086-4.18H6.242C2.849 1 .482 2.602.066 5.18a4.99 4.99 0 0 0 1.543 4.476c.146.134.39.415.39.791v7.554c0 2.757 2.244 5 5 5h10c2.758 0 5-2.243 5-5v-7.555c0-.376.243-.654.389-.787a4.99 4.99 0 0 0 1.546-4.48m-2.9 3.006c-.666.611-1.033 1.414-1.033 2.26V18c0 1.654-1.346 3-3 3H7c-1.654 0-3-1.346-3-3v-7.554c0-.845-.368-1.648-1.036-2.263a2.95 2.95 0 0 1-.923-2.686c.256-1.588 1.787-2.498 4.2-2.498h12.607c1.544 0 2.882 1.074 3.11 2.498a2.95 2.95 0 0 1-.923 2.688"
    />
  </svg>
);
export default SvgFiRrBreadSliceButter;
